/* LensTrove → Statsig custom event wiring.
 * The auto-capture bundle already tracks page views, clicks, scroll, form submits,
 * and session replay. This file layers domain-specific events on top so we can
 * answer eyewear-funnel questions (add-to-cart, color swatches, lens upgrade picks,
 * SEO landing engagement, etc.). */

(function () {
  var ctx = window.lensTroveAnalytics || {};

  /* The auto-capture CDN bundle exposes `window.Statsig.instance()` which
   * returns the StatsigClient (logEvent, updateUserAsync, checkGate, etc).
   * It auto-initializes from the ?apikey= query param on the script src. */
  function getClient() {
    var S = window.Statsig;
    if (!S) return null;
    try {
      if (typeof S.instance === 'function') return S.instance();
      return S.firstInstance || null;
    } catch (e) { return null; }
  }

  function whenReady(cb) {
    var tries = 0;
    (function poll() {
      var c = getClient();
      if (c && typeof c.logEvent === 'function') return cb(c);
      if (++tries > 200) return; // ~20s — give up quietly
      setTimeout(poll, 100);
    })();
  }

  function logEvent(name, value, metadata) {
    var c = getClient();
    if (!c || typeof c.logEvent !== 'function') return;
    try {
      c.logEvent(name, value, metadata || {});
    } catch (e) { /* swallow — analytics must not break the page */ }
  }
  window.lensTroveLogEvent = logEvent;

  whenReady(function (client) {
    /* Stitch identity + page context onto every event going forward. */
    try {
      var user = {
        userID: ctx.userID || undefined,
        email: ctx.email || undefined,
        custom: {
          page_type: ctx.pageType,
          template: ctx.template,
          handle: ctx.handle,
          cart_count: ctx.cartCount,
          cart_total: ctx.cartTotal,
          currency: ctx.currency,
          locale: ctx.locale,
          order_count: ctx.orderCount,
          total_spent: ctx.totalSpent,
          shop: ctx.shop
        }
      };
      if (client.updateUserAsync) client.updateUserAsync(user);
      else if (client.updateUserSync) client.updateUserSync(user);
    } catch (e) { /* noop */ }

    /* Page-type-specific landing event so we can slice funnel by surface. */
    var landingEvent = null;
    if (ctx.pageType === 'product') landingEvent = 'product_view';
    else if (ctx.pageType === 'collection') landingEvent = 'collection_view';
    else if (ctx.pageType === 'page' && /-glasses$/.test(ctx.handle || '')) landingEvent = 'seo_landing_view';
    else if (ctx.pageType === 'cart') landingEvent = 'cart_view';
    else if (ctx.pageType === 'index') landingEvent = 'home_view';

    if (landingEvent) {
      logEvent(landingEvent, ctx.handle || ctx.pageType, {
        path: window.location.pathname,
        referrer: document.referrer || null
      });
    }
  });

  /* ---- Color swatch picks on product cards ---- */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('[data-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.lt-card');
    var href = card && card.getAttribute('href');
    logEvent('swatch_select', swatch.getAttribute('data-color') || '', {
      product_url: href || null,
      variant_url: swatch.getAttribute('data-variant-url') || null,
      surface: ctx.pageType
    });
  }, true);

  /* ---- Wishlist heart toggles ---- */
  document.addEventListener('click', function (e) {
    var heart = e.target.closest && e.target.closest('[data-lt-heart]');
    if (!heart) return;
    var card = heart.closest('.lt-card');
    var href = card && card.getAttribute('href');
    logEvent('wishlist_toggle', href || '', { surface: ctx.pageType });
  }, true);

  /* ---- Add-to-cart on PDP and any quick-add controls ----
   * Catches both the LensTrove custom button (.lt-add-btn) and Dawn's
   * default product form submit. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lt-add-btn, [data-lt-add-to-cart]');
    if (!btn) return;
    var price = btn.getAttribute('data-price') || '';
    logEvent('add_to_cart', price, {
      product_handle: btn.getAttribute('data-product-handle') || ctx.handle || null,
      variant_id: btn.getAttribute('data-variant-id') || null,
      surface: ctx.pageType
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;
    var fd = new FormData(form);
    logEvent('add_to_cart', String(fd.get('quantity') || '1'), {
      variant_id: fd.get('id') ? String(fd.get('id')) : null,
      product_handle: ctx.handle || null,
      surface: ctx.pageType,
      via: 'form_submit'
    });
  }, true);

  /* ---- Lens-option / variant selector picks on PDP ----
   * Fires when a user changes a radio/select inside a product form. */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches) return;
    var inForm = el.closest('product-form, form[action="/cart/add"]');
    if (!inForm) return;
    if (!el.matches('input[type=radio], select')) return;
    var name = el.getAttribute('name') || '';
    if (!name) return;
    logEvent('lens_option_select', el.value, {
      option_name: name,
      product_handle: ctx.handle || null
    });
  }, true);

  /* ---- SEO landing CTA clicks ---- */
  if (/-glasses$/.test(ctx.handle || '')) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.lt-seo a, .lt-seo__cta-btn');
      if (!a) return;
      logEvent('seo_landing_cta_click', a.textContent ? a.textContent.trim().slice(0, 80) : '', {
        href: a.getAttribute('href') || null,
        landing: ctx.handle
      });
    }, true);
  }

  /* ---- Hero carousel slide engagement ---- */
  document.addEventListener('click', function (e) {
    var pager = e.target.closest && e.target.closest('.lt-hero__pager, .lt-hero__arrow');
    if (!pager) return;
    logEvent('hero_navigation', pager.getAttribute('aria-label') || pager.className, {
      surface: ctx.pageType
    });
  }, true);

  /* ---- Search submits ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.getAttribute('action') !== '/search') return;
    var q = (new FormData(form).get('q') || '').toString().trim();
    if (!q) return;
    logEvent('search_submit', q.slice(0, 120), { surface: ctx.pageType });
  }, true);
})();
